import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type ContentLang = 'ko' | 'en';

interface LocalText {
    ko: string;
    en: string;
}

interface HistoryItem {
    month: string;
    title: string;
}

interface HistoryYear {
    year: string;
    items: HistoryItem[];
}

interface TeamMember {
    _key?: string;
    name: string;
    affiliation: string;
    position: string;
    email: string;
    img: string;
    icon: string;
}

interface TeamGroup {
    id: string;
    team: string;
    title: string;
    detail: string;
    icon: string;
    member: TeamMember[];
}

interface PartnerItem {
    src: string;
    name: string;
    href: string;
}

interface PaperItem {
    id: string;
    no: number;
    year: string;
    title: string;
    kind: string;
    venue: string;
    link: string;
    visible: boolean;
}

interface ProjectItem {
    id: string;
    no: number;
    year: string;
    title: string;
    program: string;
    role: LocalText;
    status: LocalText;
    period: string;
    visible: boolean;
}

interface NewsPost {
    id: number;
    category: string;
    status: string;
    title: LocalText;
    content: LocalText;
    featured_image: string;
    upload_dir: string;
    attachments: any[];
    source_url: string;
    created: string;
}

@Component({
    selector: 'wiz-page-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin/view.scss */
:host {
  display: block;
  height: 100vh;
  color: #18181b;
  font-family: SUIT, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.admin-page {
  height: 100vh;
  overflow: hidden;
  background: #f6f7f9;
}

.admin-loading,
.admin-login {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
}

.admin-loading {
  flex-direction: column;
  gap: 14px;
  color: #52525b;
  font-size: 14px;
}

.admin-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e4e4e7;
  border-top-color: #fe5a33;
  border-radius: 999px;
  animation: admin-spin 0.8s linear infinite;
}

.login-panel {
  width: min(100%, 380px);
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 18px 45px rgba(24, 24, 27, 0.08);
}

.login-brand {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 26px;
  color: #71717a;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.login-brand img,
.sidebar-brand img {
  display: block;
  width: 104px;
  height: auto;
}

.login-panel h1 {
  margin: 0;
  font-size: 26px;
  line-height: 1.25;
  font-weight: 900;
}

.login-form {
  margin-top: 24px;
}

.login-form label {
  display: block;
  margin-bottom: 8px;
  color: #3f3f46;
  font-size: 13px;
  font-weight: 800;
}

.password-row input {
  width: 100%;
  height: 44px;
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  padding: 0 13px;
  color: #18181b;
  font-size: 14px;
  outline: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.password-row input:focus {
  border-color: #fe5a33;
  box-shadow: 0 0 0 3px rgba(254, 90, 51, 0.14);
}

.login-error {
  margin: 10px 0 0;
  color: #dc2626;
  font-size: 13px;
}

.login-button,
.logout-button {
  border: 0;
  cursor: pointer;
  font-weight: 800;
  transition: background 0.16s ease, color 0.16s ease, transform 0.16s ease;
}

.login-button {
  width: 100%;
  height: 44px;
  margin-top: 16px;
  border-radius: 8px;
  background: #fe5a33;
  color: #ffffff;
  font-size: 14px;
}

.login-button:hover:not(:disabled) {
  background: #e04420;
  transform: translateY(-1px);
}

.login-button:disabled {
  cursor: default;
  opacity: 0.65;
}

.admin-shell {
  height: 100vh;
  display: grid;
  grid-template-columns: 236px minmax(0, 1fr);
  overflow: hidden;
}

.admin-sidebar {
  height: 100vh;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 16px 12px;
  background: #ffffff;
  border-right: 1px solid #e4e4e7;
}

.sidebar-brand {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 4px 6px 14px;
}

.sidebar-brand span {
  color: #71717a;
  font-size: 11px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0;
}

.admin-session {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  padding: 9px 10px;
  background: #fff5f2;
  border: 1px solid #ffd8ce;
  border-radius: 8px;
  color: #3f3f46;
  font-size: 12px;
  font-weight: 800;
}

.session-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.14);
}

.admin-nav {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 2px 3px 10px 0;
  scrollbar-gutter: stable;
}

.admin-nav::-webkit-scrollbar,
.admin-main::-webkit-scrollbar {
  width: 8px;
}

.admin-nav::-webkit-scrollbar-thumb,
.admin-main::-webkit-scrollbar-thumb {
  background: #d4d4d8;
  border-radius: 999px;
}

.admin-menu-group + .admin-menu-group {
  margin-top: 16px;
}

.admin-menu-title {
  margin: 0 0 6px;
  padding: 0 8px;
  color: #a1a1aa;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0;
}

.admin-menu-item {
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
  padding: 8px 9px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: #3f3f46;
  cursor: pointer;
  text-align: left;
  transition: background 0.16s ease, color 0.16s ease;
}

.admin-menu-item:hover,
.admin-menu-item.active {
  background: #fff5f2;
  color: #e04420;
}

.admin-menu-item.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 9px;
  bottom: 9px;
  width: 3px;
  border-radius: 999px;
  background: #fe5a33;
}

.menu-label {
  min-width: 0;
  overflow: hidden;
  font-size: 13px;
  font-weight: 850;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menu-badge {
  padding: 2px 6px;
  border-radius: 999px;
  background: #fe5a33;
  color: #ffffff;
  font-size: 10px;
  font-weight: 900;
}

.logout-button {
  flex: 0 0 auto;
  width: 100%;
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f4f4f5;
  color: #52525b;
  font-size: 13px;
}

.logout-button:hover {
  background: #fee2e2;
  color: #dc2626;
}

.admin-main {
  height: 100vh;
  min-width: 0;
  overflow-y: auto;
  padding: 0 20px 24px;
}

.admin-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 20px;
}

.admin-eyebrow {
  margin: 0 0 8px;
  color: #fe5a33;
  font-size: 12px;
  font-weight: 900;
}

.admin-header h1 {
  margin: 0;
  font-size: clamp(28px, 3vw, 42px);
  line-height: 1.16;
  font-weight: 900;
}

.admin-header-meta {
  flex: 0 0 auto;
  display: grid;
  gap: 8px;
  min-width: 220px;
}

.admin-header-meta span {
  display: block;
  padding: 9px 10px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  color: #52525b;
  font-size: 12px;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.management-section {
  margin-top: 14px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
}

.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid #e4e4e7;
}

.section-head h2 {
  margin: 0;
  font-size: 15px;
  line-height: 1.35;
  font-weight: 900;
}

.section-head span {
  display: inline-flex;
  min-width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #f4f4f5;
  color: #71717a;
  font-size: 12px;
  font-weight: 900;
}

.management-list {
  display: grid;
}

.management-row {
  width: 100%;
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr) minmax(180px, auto);
  align-items: center;
  gap: 14px;
  padding: 13px 16px;
  background: #ffffff;
  border: 0;
  border-bottom: 1px solid #f0f0f1;
  color: #18181b;
  cursor: pointer;
  text-align: left;
}

.management-row:last-child {
  border-bottom: 0;
}

.management-row:hover {
  background: #fffaf8;
}

.row-title {
  min-width: 0;
  font-size: 14px;
  font-weight: 900;
}

.row-path {
  min-width: 0;
  overflow: hidden;
  color: #71717a;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}

.row-tags span {
  max-width: 100%;
  padding: 4px 7px;
  border-radius: 7px;
  background: #fafafa;
  border: 1px solid #e4e4e7;
  color: #3f3f46;
  font-size: 11px;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.admin-spinner.small {
  width: 18px;
  height: 18px;
  border-width: 2px;
}

.history-admin,
.organization-admin,
.papers-admin,
.projects-admin,
.news-admin {
  display: grid;
  gap: 22px;
}

.history-toolbar {
  position: sticky;
  top: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin: 0 -20px;
  padding: 14px 20px;
  background: #ffffff;
  border: 0;
  border-bottom: 1px solid #cfd4dc;
  border-radius: 0;
  box-shadow: 0 8px 18px rgba(24, 24, 27, 0.08);
}

.history-tabs {
  display: inline-flex;
  padding: 3px;
  background: #f4f4f5;
  border-radius: 8px;
}

.history-tabs button {
  min-width: 56px;
  height: 34px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #52525b;
  cursor: pointer;
  font-size: 12px;
  font-weight: 900;
}

.history-tabs button.active {
  background: #ffffff;
  color: #18181b;
  box-shadow: 0 1px 3px rgba(24, 24, 27, 0.08);
}

.history-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.history-state {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  max-width: 96px;
  padding: 0 10px;
  border-radius: 999px;
  background: #ecfdf5;
  color: #047857;
  font-size: 12px;
  font-weight: 900;
  line-height: 1;
  white-space: nowrap;
}

.history-state.dirty {
  background: #fff7ed;
  color: #c2410c;
}

.history-state.error {
  background: #fef2f2;
  color: #b91c1c;
}

.history-state.success {
  background: #ecfdf5;
  color: #047857;
}

.admin-action,
.add-year-button,
.add-item-button,
.icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #3f3f46;
  cursor: pointer;
  font-weight: 900;
  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease, transform 0.16s ease;
}

.admin-action {
  min-height: 34px;
  gap: 6px;
  padding: 0 11px;
  border-radius: 8px;
  font-size: 12px;
}

.admin-action i,
.add-year-button i,
.add-item-button i {
  font-size: 15px;
}

.admin-action.primary {
  border-color: #fe5a33;
  background: #fe5a33;
  color: #ffffff;
}

.admin-action:hover:not(:disabled),
.add-year-button:hover:not(:disabled),
.add-item-button:hover:not(:disabled),
.icon-button:hover:not(:disabled) {
  border-color: #fecaca;
  background: #fff5f2;
  color: #e04420;
  transform: translateY(-1px);
}

.admin-action.primary:hover:not(:disabled) {
  border-color: #e04420;
  background: #e04420;
  color: #ffffff;
}

.admin-action:disabled,
.add-year-button:disabled,
.add-item-button:disabled,
.icon-button:disabled {
  cursor: default;
  opacity: 0.45;
  transform: none;
}

.history-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.history-summary div {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
}

.history-summary strong {
  color: #18181b;
  font-size: 21px;
  line-height: 1;
  font-weight: 950;
}

.history-summary span {
  color: #71717a;
  font-size: 12px;
  font-weight: 900;
}

.history-loading,
.history-empty {
  min-height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  color: #71717a;
  font-size: 14px;
  font-weight: 850;
}

.history-empty {
  flex-direction: column;
}

.history-empty i {
  color: #a1a1aa;
  font-size: 28px;
}

.history-empty p {
  margin: 0;
}

.history-board {
  display: grid;
  gap: 12px;
}

.history-year-card {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
}

.year-card-head {
  display: grid;
  grid-template-columns: 38px minmax(160px, 240px) minmax(120px, auto);
  align-items: end;
  gap: 10px;
  padding: 13px 14px;
  background: #fbfbfc;
  border-bottom: 1px solid #ececf0;
}

.icon-button {
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  border-radius: 8px;
  font-size: 15px;
}

.icon-button.danger:hover:not(:disabled) {
  border-color: #fecaca;
  background: #fef2f2;
  color: #dc2626;
}

.history-drag-handle,
.item-drag-handle {
  cursor: grab;
}

.history-drag-handle:active,
.item-drag-handle:active {
  cursor: grabbing;
}

.year-input,
.month-input,
.title-input {
  display: grid;
  gap: 6px;
  min-width: 0;
}

.year-input span,
.month-input span,
.title-input span {
  color: #71717a;
  font-size: 11px;
  font-weight: 900;
}

.year-input input,
.month-input input,
.title-input textarea {
  width: 100%;
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  background: #ffffff;
  color: #18181b;
  font-size: 13px;
  font-weight: 750;
  outline: none;
  transition: border-color 0.16s ease, box-shadow 0.16s ease;
}

.year-input input,
.month-input input {
  height: 36px;
  padding: 0 10px;
}

.title-input textarea {
  min-height: 58px;
  padding: 9px 10px;
  line-height: 1.45;
  resize: none;
}

.year-input input:focus,
.month-input input:focus,
.title-input textarea:focus {
  border-color: #fe5a33;
  box-shadow: 0 0 0 3px rgba(254, 90, 51, 0.12);
}

.year-tools,
.item-tools {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.year-items {
  display: grid;
}

.history-item-row {
  display: grid;
  grid-template-columns: 38px 112px minmax(0, 1fr) minmax(120px, auto);
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-bottom: 1px solid #f0f0f1;
}

.history-item-row:last-child {
  border-bottom: 0;
}

.history-item-row:hover {
  background: #fffaf8;
}

.add-item-button {
  width: calc(100% - 28px);
  min-height: 38px;
  gap: 6px;
  margin: 0 14px 14px;
  border-style: dashed;
  border-radius: 8px;
  color: #52525b;
  font-size: 13px;
}

.add-year-button {
  width: 100%;
  min-height: 44px;
  gap: 7px;
  border-style: dashed;
  border-radius: 8px;
  color: #3f3f46;
  font-size: 14px;
}

.drag-ghost {
  opacity: 0.45;
}

.drag-chosen {
  box-shadow: 0 12px 28px rgba(24, 24, 27, 0.12);
}

.drag-active {
  opacity: 0.9;
}

.organization-board {
  display: grid;
  gap: 8px;
}

.organization-card {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
}

.organization-card .icon-button {
  width: 30px;
  height: 30px;
  border-radius: 7px;
  font-size: 14px;
}

.organization-card .year-tools,
.organization-card .item-tools {
  gap: 4px;
}

.organization-card .add-item-button {
  width: calc(100% - 20px);
  min-height: 32px;
  margin: 0 10px 10px;
  font-size: 12px;
}

.organization-admin > .add-year-button {
  min-height: 38px;
  font-size: 13px;
}

.organization-card-head {
  display: grid;
  grid-template-columns: 32px 34px minmax(96px, 0.7fr) minmax(128px, 1fr) 124px minmax(104px, auto);
  align-items: end;
  gap: 8px;
  padding: 8px 10px;
  background: #fbfbfc;
  border-bottom: 1px solid #ececf0;
}

.organization-icon-preview,
.member-icon-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #fff5f2;
  color: #fe5a33;
}

.organization-icon-preview {
  width: 32px;
  height: 32px;
  align-self: end;
  font-size: 16px;
}

.member-icon-preview {
  width: 30px;
  height: 30px;
  font-size: 15px;
}

.org-field,
.org-detail-field {
  display: grid;
  gap: 4px;
  min-width: 0;
}

.org-detail-field {
  padding: 8px 10px;
  border-bottom: 1px solid #f0f0f1;
}

.org-field span,
.org-detail-field span {
  color: #71717a;
  font-size: 11px;
  font-weight: 900;
}

.org-field input,
.org-field select,
.org-detail-field textarea {
  width: 100%;
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  background: #ffffff;
  color: #18181b;
  font-size: 12px;
  font-weight: 750;
  outline: none;
  transition: border-color 0.16s ease, box-shadow 0.16s ease;
}

.org-field input,
.org-field select {
  height: 32px;
  padding: 0 8px;
}

.org-field select {
  cursor: pointer;
}

.org-detail-field textarea {
  min-height: 44px;
  padding: 7px 8px;
  line-height: 1.38;
  resize: vertical;
}

.org-field input:focus,
.org-field select:focus,
.org-detail-field textarea:focus {
  border-color: #fe5a33;
  box-shadow: 0 0 0 3px rgba(254, 90, 51, 0.12);
}

.member-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border-bottom: 1px solid #f0f0f1;
}

.member-section-head h2 {
  margin: 0;
  color: #18181b;
  font-size: 12px;
  font-weight: 950;
}

.member-section-head span {
  display: inline-flex;
  min-width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #f4f4f5;
  color: #71717a;
  font-size: 11px;
  font-weight: 900;
}

.member-list {
  display: grid;
}

.member-row {
  display: grid;
  grid-template-columns: 32px 30px minmax(0, 1fr) minmax(104px, auto);
  align-items: start;
  gap: 8px;
  padding: 8px 10px;
  border-bottom: 1px solid #f0f0f1;
}

.member-row:last-child {
  border-bottom: 0;
}

.member-row:hover {
  background: #fffaf8;
}

.member-fields {
  display: grid;
  grid-template-columns: minmax(90px, 0.7fr) minmax(105px, 0.8fr) minmax(96px, 0.75fr) minmax(140px, 1fr) minmax(150px, 1.1fr) 112px;
  gap: 8px;
  min-width: 0;
}

.papers-title-block {
  display: grid;
  gap: 4px;
  min-width: 0;
}

.papers-title-block strong {
  color: #18181b;
  font-size: 14px;
  font-weight: 950;
}

.papers-title-block span {
  color: #71717a;
  font-size: 12px;
  font-weight: 750;
}

.paper-table-scroll {
  overflow-x: auto;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
}

.paper-edit-table {
  width: 100%;
  min-width: 1080px;
  border-collapse: collapse;
  table-layout: fixed;
}

.project-edit-table {
  min-width: 1400px;
}

.paper-edit-table th,
.paper-edit-table td {
  border-bottom: 1px solid #f0f0f1;
  padding: 7px 8px;
  vertical-align: middle;
  text-align: left;
}

.paper-edit-table th {
  height: 34px;
  background: #fbfbfc;
  color: #71717a;
  font-size: 11px;
  font-weight: 950;
}

.paper-edit-table tbody tr:last-child td {
  border-bottom: 0;
}

.paper-edit-table tbody tr:hover td {
  background: #fffaf8;
}

.paper-edit-table input,
.paper-edit-table textarea {
  width: 100%;
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  background: #ffffff;
  color: #18181b;
  font-size: 13px;
  font-weight: 750;
  outline: none;
  transition: border-color 0.16s ease, box-shadow 0.16s ease;
}

.paper-edit-table input {
  height: 32px;
  padding: 0 9px;
}

.paper-edit-table textarea {
  min-height: 44px;
  padding: 7px 9px;
  line-height: 1.35;
  resize: vertical;
}

.paper-edit-table input:focus,
.paper-edit-table textarea:focus {
  border-color: #fe5a33;
  box-shadow: 0 0 0 3px rgba(254, 90, 51, 0.12);
}

.paper-col-no {
  width: 104px;
}

.paper-col-year {
  width: 96px;
}

.paper-col-kind {
  width: 132px;
}

.paper-col-visible {
  width: 92px;
}

.paper-col-actions {
  width: 132px;
}

.project-col-no {
  width: 104px;
}

.project-col-year {
  width: 96px;
}

.project-col-title {
  width: 250px;
}

.project-col-program {
  width: 200px;
}

.project-col-lang {
  width: 120px;
}

.project-col-period {
  width: 170px;
}

.project-col-visible {
  width: 92px;
}

.project-col-actions {
  width: 132px;
}

.paper-no-cell,
.paper-row-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.paper-no-cell input {
  min-width: 0;
}

.paper-drag-handle,
.project-drag-handle {
  cursor: grab;
}

.paper-drag-handle:active,
.project-drag-handle:active {
  cursor: grabbing;
}

.paper-visible-toggle {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #3f3f46;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}

.paper-visible-toggle input {
  width: 16px;
  height: 16px;
  padding: 0;
  accent-color: #fe5a33;
}

.team-drag-handle,
.member-drag-handle {
  cursor: grab;
  touch-action: none;
  user-select: none;
}

.team-drag-handle:active,
.member-drag-handle:active {
  cursor: grabbing;
}

@media (max-width: 1080px) {
  .admin-shell {
    grid-template-columns: 220px minmax(0, 1fr);
  }
  .admin-main {
    padding: 0 16px 22px;
  }
  .history-toolbar {
    margin-right: -16px;
    margin-left: -16px;
    padding-right: 16px;
    padding-left: 16px;
  }
  .management-row {
    grid-template-columns: 140px minmax(0, 1fr);
  }
  .row-tags {
    grid-column: 1/-1;
    justify-content: flex-start;
  }
  .history-item-row {
    grid-template-columns: 38px 96px minmax(0, 1fr);
  }
  .organization-card-head {
    grid-template-columns: 32px 34px minmax(110px, 1fr) minmax(130px, 1fr);
  }
  .organization-card-head .icon-select,
  .organization-card-head .year-tools {
    grid-column: 3/-1;
  }
  .member-row {
    grid-template-columns: 32px 30px minmax(0, 1fr);
  }
  .member-fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .member-tools {
    grid-column: 3/-1;
    justify-content: flex-start;
  }
  .item-tools {
    grid-column: 2/-1;
    justify-content: flex-start;
  }
}
@media (max-width: 820px) {
  :host,
  .admin-page {
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }
  .admin-shell {
    display: block;
    height: auto;
    overflow: visible;
  }
  .admin-sidebar,
  .admin-main {
    height: auto;
    min-height: auto;
    overflow: visible;
  }
  .admin-sidebar {
    border-right: 0;
    border-bottom: 1px solid #e4e4e7;
  }
  .admin-header {
    display: block;
  }
  .admin-header-meta {
    margin-top: 16px;
  }
  .management-row {
    grid-template-columns: 1fr;
    gap: 7px;
  }
  .row-path {
    white-space: normal;
  }
  .history-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .history-actions,
  .history-tabs {
    width: 100%;
  }
  .history-actions {
    justify-content: flex-start;
  }
  .history-summary {
    grid-template-columns: 1fr;
  }
  .year-card-head,
  .history-item-row,
  .organization-card-head,
  .member-row {
    grid-template-columns: 34px minmax(0, 1fr);
  }
  .year-tools,
  .item-tools,
  .organization-card-head .year-tools,
  .member-tools {
    grid-column: 2/-1;
    justify-content: flex-start;
  }
  .month-input,
  .title-input,
  .organization-icon-preview,
  .member-icon-preview,
  .org-field,
  .member-fields,
  .organization-card-head .icon-select {
    grid-column: 2/-1;
  }
  .member-fields {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 520px) {
  .admin-login {
    padding: 18px;
  }
  .admin-main {
    padding: 0 18px 22px;
  }
  .login-panel {
    padding: 24px;
  }
  .history-toolbar {
    margin-right: -18px;
    margin-left: -18px;
    padding-right: 18px;
    padding-left: 18px;
  }
}
@keyframes admin-spin {
  to {
    transform: rotate(360deg);
  }
}
.news-toolbar {
  align-items: center;
}

.news-filters,
.news-meta-grid {
  display: grid;
  gap: 10px;
}

.news-filters {
  grid-template-columns: minmax(220px, 1fr) 150px 130px auto;
  margin: 0;
}

.news-meta-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-bottom: 14px;
}

.news-filters label,
.news-meta-grid label,
.news-title-field {
  display: grid;
  gap: 7px;
  color: #52525b;
  font-size: 12px;
  font-weight: 800;
}

.news-filters input,
.news-filters select,
.news-meta-grid input,
.news-meta-grid select,
.news-title-field input {
  width: 100%;
  min-width: 0;
  height: 38px;
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  padding: 0 11px;
  background: #ffffff;
  color: #18181b;
  font-size: 13px;
  outline: none;
}

.news-filters input:focus,
.news-filters select:focus,
.news-meta-grid input:focus,
.news-meta-grid select:focus,
.news-title-field input:focus {
  border-color: #fe5a33;
  box-shadow: 0 0 0 3px rgba(254, 90, 51, 0.12);
}

.news-table-scroll {
  overflow-x: auto;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #ffffff;
}

.news-edit-table {
  width: 100%;
  min-width: 860px;
  border-collapse: collapse;
}

.news-edit-table th,
.news-edit-table td {
  padding: 12px 14px;
  border-bottom: 1px solid #eeeeef;
  text-align: left;
  vertical-align: middle;
  font-size: 13px;
}

.news-edit-table th {
  color: #71717a;
  font-size: 11px;
  font-weight: 900;
  background: #fafafa;
}

.news-edit-table tbody tr {
  cursor: pointer;
}

.news-edit-table tbody tr:hover {
  background: #fff8f5;
}

.news-title-cell {
  display: grid;
  gap: 4px;
  min-width: 0;
}

.news-title-cell strong,
.news-title-cell span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-title-cell strong {
  color: #18181b;
  font-size: 14px;
}

.news-title-cell span {
  color: #71717a;
  font-size: 12px;
}

.news-status-badge {
  display: inline-flex;
  align-items: center;
  min-width: 48px;
  height: 24px;
  justify-content: center;
  border-radius: 999px;
  padding: 0 9px;
  font-size: 11px;
  font-weight: 900;
}

.news-status-badge.publish {
  background: #ecfdf5;
  color: #047857;
}

.news-status-badge.draft {
  background: #f4f4f5;
  color: #52525b;
}

.news-pagination {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 14px;
}

.page-button {
  width: 34px;
  height: 34px;
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  background: #ffffff;
  color: #3f3f46;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}

.page-button.active {
  border-color: #fe5a33;
  background: #fe5a33;
  color: #ffffff;
}

.news-editor-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 16px;
  align-items: start;
}

.news-editor-main,
.news-asset-panel {
  min-width: 0;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #ffffff;
  padding: 16px;
}

.news-lang-tabs {
  margin-bottom: 18px;
}

.news-content-editor {
  margin-top: 14px;
}

.news-content-editor textarea {
  min-height: 480px;
}

:host ::ng-deep .news-content-editor .ck-editor__editable.ck-content {
  min-height: 480px;
  padding: 28px;
  color: #3F3F46;
  font-family: SUIT, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 17px;
  line-height: 1.86;
}

:host ::ng-deep .news-content-editor .ck-content h1,
:host ::ng-deep .news-content-editor .ck-content h2,
:host ::ng-deep .news-content-editor .ck-content h3,
:host ::ng-deep .news-content-editor .ck-content h4,
:host ::ng-deep .news-content-editor .ck-content h5,
:host ::ng-deep .news-content-editor .ck-content h6 {
  margin: 2em 0 0.75em;
  color: #18181B;
  font-weight: 800;
  line-height: 1.35;
  letter-spacing: 0;
}

:host ::ng-deep .news-content-editor .ck-content h1 {
  font-size: 30px;
}

:host ::ng-deep .news-content-editor .ck-content h2 {
  font-size: 25px;
}

:host ::ng-deep .news-content-editor .ck-content h3 {
  font-size: 21px;
}

:host ::ng-deep .news-content-editor .ck-content p {
  margin: 0 0 1.3em;
  color: #3F3F46;
}

:host ::ng-deep .news-content-editor .ck-content strong {
  color: #18181B;
  font-weight: 800;
}

:host ::ng-deep .news-content-editor .ck-content ul,
:host ::ng-deep .news-content-editor .ck-content ol {
  margin: 0 0 1.4em;
  padding-left: 1.45em;
}

:host ::ng-deep .news-content-editor .ck-content li {
  margin-bottom: 0.55em;
}

:host ::ng-deep .news-content-editor .ck-content a {
  color: #E04420;
  text-decoration: underline;
  text-underline-offset: 3px;
}

:host ::ng-deep .news-content-editor .ck-content hr {
  margin: 32px 0;
  border: 0;
  border-top: 1px solid #E4E4E7;
}

:host ::ng-deep .news-content-editor .ck-content blockquote {
  margin: 1.6em 0;
  padding: 2px 0 2px 18px;
  border-left: 3px solid #FE5A33;
  color: #71717A;
}

:host ::ng-deep .news-content-editor .ck-content img {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 28px auto;
  border-radius: 8px;
}

:host ::ng-deep .news-content-editor .ck-content figure.image {
  margin: 28px auto;
}

:host ::ng-deep .news-content-editor .ck-content table {
  width: 100%;
  margin: 28px 0;
  border-collapse: collapse;
  font-size: 15px;
}

:host ::ng-deep .news-content-editor .ck-content th,
:host ::ng-deep .news-content-editor .ck-content td {
  padding: 12px 14px;
  border: 1px solid #E4E4E7;
  text-align: left;
  vertical-align: top;
}

:host ::ng-deep .news-content-editor .ck-content th {
  background: #FAFAFA;
  color: #18181B;
  font-weight: 800;
}

.asset-preview {
  overflow: hidden;
  margin-bottom: 14px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  aspect-ratio: 16/10;
  background: #f4f4f5;
}

.asset-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.asset-upload-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin: 12px 0;
}

.asset-upload-button {
  position: relative;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  background: #ffffff;
  color: #3f3f46;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}

.asset-upload-button input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.asset-uploading,
.asset-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.asset-uploading {
  margin: 10px 0;
  color: #52525b;
  font-size: 12px;
  font-weight: 800;
}

.asset-list {
  display: grid;
  gap: 8px;
  margin-top: 12px;
}

.asset-row {
  min-width: 0;
  padding: 8px;
  border: 1px solid #eeeeef;
  border-radius: 8px;
}

.asset-row > i {
  color: #fe5a33;
}

.asset-row a {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  color: #3f3f46;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.history-empty.compact {
  min-height: 120px;
  margin-top: 12px;
}

@media (max-width: 1180px) {
  .news-editor-layout {
    grid-template-columns: 1fr;
  }
  .news-meta-grid,
  .news-filters {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .news-meta-grid,
  .news-filters {
    grid-template-columns: 1fr;
  }
}
.history-admin {
  gap: 22px;
}

.history-admin .history-toolbar {
  gap: 8px;
  padding-top: 12px;
  padding-bottom: 12px;
}

.history-compact-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  min-width: 0;
}

.history-compact-meta span {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  padding: 0 7px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #fafafa;
  color: #52525b;
  font-size: 11px;
  font-weight: 900;
}

.history-admin .history-tabs {
  padding: 2px;
  border-radius: 7px;
}

.history-admin .history-tabs button {
  min-width: 42px;
  height: 28px;
  border-radius: 5px;
  font-size: 11px;
}

.history-admin .history-actions {
  gap: 5px;
}

.history-admin .history-state {
  min-height: 28px;
  padding: 0 8px;
  font-size: 11px;
}

.history-admin .admin-action {
  min-height: 30px;
  gap: 4px;
  padding: 0 8px;
  border-radius: 6px;
  font-size: 11px;
}

.history-admin .history-loading,
.history-admin .history-empty {
  min-height: 86px;
  font-size: 13px;
}

.history-admin .history-board {
  gap: 6px;
}

.history-admin .history-year-card {
  border-radius: 6px;
}

.history-admin .year-card-head {
  grid-template-columns: 30px 112px minmax(92px, auto);
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
}

.history-admin .icon-button {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  font-size: 13px;
}

.history-admin .year-input,
.history-admin .month-input,
.history-admin .title-input {
  gap: 0;
}

.history-admin .year-input span,
.history-admin .month-input span,
.history-admin .title-input span {
  display: none;
}

.history-admin .year-input input,
.history-admin .month-input input,
.history-admin .title-input input {
  width: 100%;
  height: 30px;
  padding: 0 8px;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #ffffff;
  color: #18181b;
  font-size: 12px;
  font-weight: 750;
  outline: none;
}

.history-admin .year-input input:focus,
.history-admin .month-input input:focus,
.history-admin .title-input input:focus {
  border-color: #fe5a33;
  box-shadow: 0 0 0 2px rgba(254, 90, 51, 0.1);
}

.history-admin .year-tools,
.history-admin .item-tools {
  gap: 4px;
}

.history-admin .history-item-row {
  grid-template-columns: 30px 72px minmax(220px, 1fr) 96px;
  gap: 6px;
  padding: 6px 8px;
}

.history-admin .add-item-button {
  width: calc(100% - 16px);
  min-height: 30px;
  margin: 0 8px 8px;
  border-radius: 6px;
  font-size: 12px;
}

@media (max-width: 1080px) {
  .history-admin .history-item-row {
    grid-template-columns: 30px 72px minmax(180px, 1fr) 96px;
  }
}
@media (max-width: 820px) {
  .history-admin .history-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .history-compact-meta,
  .history-admin .history-actions,
  .history-admin .history-tabs {
    width: 100%;
  }
  .history-admin .history-item-row {
    grid-template-columns: 28px 68px minmax(0, 1fr);
  }
  .history-admin .item-tools {
    grid-column: 2/-1;
  }
}
.partners-error {
  margin: 12px 0;
  padding: 10px 14px;
  border: 1px solid #fecaca;
  border-radius: 8px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 13px;
}

.partners-hint {
  margin: 12px 0;
  color: #71717a;
  font-size: 13px;
  line-height: 1.6;
}

.partners-editor {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

.partners-board {
  display: grid;
  gap: 12px;
}

.partner-admin-card {
  display: grid;
  grid-template-columns: 140px minmax(0, 1fr) auto;
  gap: 16px;
  align-items: center;
  padding: 16px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fff;
}

.partner-admin-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  height: 96px;
  padding: 12px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fafafa;
  color: #a1a1aa;
}

.partner-admin-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.partner-admin-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  min-width: 0;
}

.partner-logo-field {
  grid-column: 1/-1;
}

.partner-logo-upload {
  width: fit-content;
  padding: 0 12px;
}

@media (max-width: 767px) {
  .partner-admin-card {
    grid-template-columns: 1fr auto;
  }
  .partner-admin-logo {
    grid-column: 1/-1;
  }
  .partner-admin-fields {
    grid-template-columns: minmax(0, 1fr);
  }
}`],
})
export class PageAdminComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    public authenticated: boolean = false;
    public checking: boolean = true;
    public busy: boolean = false;
    public activeKey: string = 'about-history';
    public error: string = '';

    public historyLoaded: boolean = false;
    public historyBusy: boolean = false;
    public historySaving: boolean = false;
    public historyDirty: boolean = false;
    public historyMessage: string = '';
    public historyError: string = '';

    public teamLoaded: boolean = false;
    public teamBusy: boolean = false;
    public teamSaving: boolean = false;
    public teamDirty: boolean = false;
    public teamMessage: string = '';
    public teamError: string = '';

    public partnersLoaded = false;
    public partnersBusy = false;
    public partnersSaving = false;
    public partnersUploading = false;
    public partnersDirty = false;
    public partnersMessage = '';
    public partnersError = '';
    public partnersDraft: any = this.emptyPartners();

    public papersLoaded: boolean = false;
    public papersBusy: boolean = false;
    public papersSaving: boolean = false;
    public papersDirty: boolean = false;
    public papersMessage: string = '';
    public papersError: string = '';

    public projectsLoaded: boolean = false;
    public projectsBusy: boolean = false;
    public projectsSaving: boolean = false;
    public projectsDirty: boolean = false;
    public projectsMessage: string = '';
    public projectsError: string = '';

    public newsLoaded: boolean = false;
    public newsBusy: boolean = false;
    public newsSaving: boolean = false;
    public newsUploading: boolean = false;
    public newsDirty: boolean = false;
    public newsMessage: string = '';
    public newsError: string = '';
    public newsMode: 'list' | 'edit' = 'list';
    public newsRows: NewsPost[] = [];
    public newsDraft: NewsPost = this.emptyNewsPost();
    public newsTotal: number = 0;
    public newsStats: any = { total: 0, draft: 0, publish: 0, notice: 0, article: 0, report: 0 };
    public newsSearch: any = { page: 1, keyword: '', category: '', status: '', dump: 20 };
    public newsPagination: any = { start: -1, end: -1 };
    public ckeditorReady: boolean = false;

    public activeLang: ContentLang = 'ko';
    public historyDraft: any = this.emptyHistory();
    public teamDraft: any = this.emptyTeam();
    public papersDraft: any = this.emptyPapers();
    public projectsDraft: any = this.emptyProjects();

    private newsEditor: any = null;
    private ckeditorPromise: Promise<any> | null = null;

    public iconOptions: any[] = [
        { label: '사용자', value: 'icon-user' },
        { label: '그룹', value: 'icon-users' },
        { label: '경영', value: 'icon-briefcase' },
        { label: '운영', value: 'icon-target' },
        { label: '연구', value: 'icon-brain-circuit' },
        { label: '개발', value: 'icon-code-2' },
        { label: '데이터', value: 'icon-database' },
        { label: '실험', value: 'icon-microscope' },
        { label: '웹', value: 'icon-layout-dashboard' },
        { label: '서버', value: 'icon-server' },
        { label: '성장', value: 'icon-rocket' },
        { label: '보안', value: 'icon-shield-check' }
    ];

    public newsCategoryOptions: any[] = [
        { label: '공지사항', value: 'notice' },
        { label: '보도자료', value: 'article' },
        { label: '보고서', value: 'report' }
    ];

    public newsStatusOptions: any[] = [
        { label: '초안', value: 'draft' },
        { label: '공개', value: 'publish' }
    ];

    public yearSortableOptions: any = {
        animation: 150,
        handle: '.history-drag-handle',
        draggable: '.history-year-card',
        ghostClass: 'drag-ghost',
        chosenClass: 'drag-chosen',
        dragClass: 'drag-active',
        forceFallback: true,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        filter: 'input, textarea, select, option, .icon-button:not(.history-drag-handle)',
        preventOnFilter: false,
        onUpdate: () => this.afterHistorySort()
    };

    public itemSortableOptions: any = {
        animation: 150,
        handle: '.item-drag-handle',
        draggable: '.history-item-row',
        ghostClass: 'drag-ghost',
        chosenClass: 'drag-chosen',
        dragClass: 'drag-active',
        forceFallback: true,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        filter: 'input, textarea, select, option, .icon-button:not(.item-drag-handle)',
        preventOnFilter: false,
        onUpdate: () => this.afterHistorySort()
    };

    public teamSortableOptions: any = {
        animation: 150,
        handle: '.team-drag-handle',
        draggable: '.organization-card',
        ghostClass: 'drag-ghost',
        chosenClass: 'drag-chosen',
        dragClass: 'drag-active',
        forceFallback: true,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        filter: 'input, textarea, select, option, .icon-button:not(.team-drag-handle)',
        preventOnFilter: false,
        onUpdate: () => this.afterTeamSort()
    };

    public memberSortableOptions: any = {
        animation: 150,
        handle: '.member-drag-handle',
        draggable: '.member-row',
        ghostClass: 'drag-ghost',
        chosenClass: 'drag-chosen',
        dragClass: 'drag-active',
        forceFallback: true,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        filter: 'input, textarea, select, option, .icon-button:not(.member-drag-handle)',
        preventOnFilter: false,
        onUpdate: () => this.afterTeamSort()
    };

    public paperSortableOptions: any = {
        animation: 150,
        handle: '.paper-drag-handle',
        draggable: 'tr',
        ghostClass: 'drag-ghost',
        chosenClass: 'drag-chosen',
        dragClass: 'drag-active',
        forceFallback: true,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        filter: 'input, textarea, select, option, .icon-button:not(.paper-drag-handle)',
        preventOnFilter: false,
        onUpdate: () => this.afterPaperSort()
    };

    public projectSortableOptions: any = {
        animation: 150,
        handle: '.project-drag-handle',
        draggable: 'tr',
        ghostClass: 'drag-ghost',
        chosenClass: 'drag-chosen',
        dragClass: 'drag-active',
        forceFallback: true,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        filter: 'input, textarea, select, option, .icon-button:not(.project-drag-handle)',
        preventOnFilter: false,
        onUpdate: () => this.afterProjectSort()
    };

    public form: any = {
        password: ''
    };

    public menuSections: any[] = [
        {
            title: 'About',
            items: [
                { key: 'about-history', label: '연혁' },
                { key: 'about-organization', label: '조직' },
                { key: 'about-partners', label: '파트너' }
            ]
        },
        {
            title: 'Research',
            items: [
                { key: 'research-papers', label: '논문' },
                { key: 'research-projects', label: '연구과제' }
            ]
        },
        {
            title: '뉴스',
            items: [
                { key: 'news-posts', label: '게시글 관리' },
                { key: 'news-categories', label: '카테고리 관리' }
            ]
        },
        {
            title: '시스템 설정',
            items: [
                { key: 'system-stats', label: '사이트 통계' },
                { key: 'system-chatbot-logs', label: 'AI 챗봇 로그' },
                { key: 'system-inquiries', label: '문의사항' }
            ]
        }
    ];

    public panels: any = {
        'about-history': {
            category: 'About',
            title: '연혁',
            publicPath: '/about#history',
            adminPath: '/admin/about/history',
            groups: [
                { title: '연혁', items: [
                    { label: '연혁 목록', path: '/admin/about/history', tags: ['목록', '정렬'] },
                    { label: '연도 관리', path: '/admin/about/history/year', tags: ['year'] },
                    { label: '월별 항목', path: '/admin/about/history/item', tags: ['month', 'title'] }
                ] }
            ]
        },
        'about-organization': {
            category: 'About',
            title: '조직',
            publicPath: '/about#team',
            adminPath: '/admin/about/organization',
            groups: [
                { title: '조직', items: [
                    { label: '부서 관리', path: '/admin/about/organization/departments', tags: ['팀', '순서'] },
                    { label: '구성원 관리', path: '/admin/about/organization/members', tags: ['프로필', '이미지'] },
                    { label: '파트너 관리', path: '/admin/about/organization/partners', tags: ['로고'] }
                ] }
            ]
        },
        'about-partners': {
            category: 'About',
            title: '파트너',
            publicPath: '/about#partners',
            adminPath: '/admin/about/partner',
            aliases: ['/admin/about/organization/partners'],
            groups: []
        },
        'research-papers': {
            category: 'Research',
            title: '논문',
            publicPath: '/research',
            adminPath: '/admin/research/papers',
            groups: [
                { title: '논문', items: [
                    { label: '논문 목록', path: '/admin/research/papers', tags: ['목록', '검색'] },
                    { label: '논문 등록', path: '/admin/research/papers/new', tags: ['제목', '링크'] },
                    { label: '분류/연도', path: '/admin/research/papers/meta', tags: ['연도', '분류'] }
                ] }
            ]
        },
        'research-projects': {
            category: 'Research',
            title: '연구과제',
            publicPath: '/research',
            adminPath: '/admin/research/projects',
            groups: [
                { title: '연구과제', items: [
                    { label: '과제 목록', path: '/admin/research/projects', tags: ['목록', '검색'] },
                    { label: '과제 등록', path: '/admin/research/projects/new', tags: ['기간', '기관'] },
                    { label: '성과 연결', path: '/admin/research/projects/results', tags: ['논문', '특허'] }
                ] }
            ]
        },
        'news-posts': {
            category: '뉴스',
            title: '게시글 관리',
            publicPath: '/news',
            adminPath: '/admin/news/posts',
            groups: [
                { title: '게시글', items: [
                    { label: '전체 게시글', path: '/admin/news/posts', tags: ['목록', '검색'] },
                    { label: '게시글 작성', path: '/admin/news/posts/new', tags: ['작성'] },
                    { label: '공개 상태', path: '/admin/news/posts/status', tags: ['공개', '비공개'] },
                    { label: '대표 이미지', path: '/admin/news/posts/assets', tags: ['featured'] }
                ] }
            ]
        },
        'news-categories': {
            category: '뉴스',
            title: '카테고리 관리',
            publicPath: '/news',
            adminPath: '/admin/news/categories',
            groups: [
                { title: '카테고리', items: [
                    { label: '공지사항', path: '/admin/news/categories/notice', tags: ['notice'] },
                    { label: '보도자료', path: '/admin/news/categories/article', tags: ['article'] },
                    { label: '보고서', path: '/admin/news/categories/report', tags: ['report'] },
                    { label: '노출 순서', path: '/admin/news/categories/order', tags: ['정렬'] }
                ] }
            ]
        },
        'system-stats': {
            category: '시스템 설정',
            title: '사이트 통계',
            publicPath: 'site',
            adminPath: '/admin/system/stats',
            groups: [
                { title: '사이트 통계', items: [
                    { label: '방문 현황', path: '/admin/system/stats/visits', tags: ['PV', 'UV'] },
                    { label: '페이지별 통계', path: '/admin/system/stats/pages', tags: ['경로'] },
                    { label: '콘텐츠 현황', path: '/admin/system/stats/content', tags: ['뉴스', '문의'] }
                ] }
            ]
        },
        'system-chatbot-logs': {
            category: '시스템 설정',
            title: 'AI 챗봇 로그',
            publicPath: 'component.chatbot',
            adminPath: '/admin/system/chatbot/logs',
            groups: [
                { title: 'AI 챗봇 로그', items: [
                    { label: 'Q&A 로그', path: '/admin/system/chatbot/logs', tags: ['qna', 'ip'] },
                    { label: '응답 실패', path: '/admin/system/chatbot/errors', tags: ['fallback'] },
                    { label: '내비게이션 클릭', path: '/admin/system/chatbot/navigation', tags: ['NAV'] }
                ] }
            ]
        },
        'system-inquiries': {
            category: '시스템 설정',
            title: '문의사항',
            publicPath: '/contact',
            adminPath: '/admin/system/inquiries',
            groups: [
                { title: '문의사항', items: [
                    { label: '전체 문의', path: '/admin/system/inquiries', tags: ['목록', '검색'] },
                    { label: '문의 유형', path: '/admin/system/inquiries/types', tags: ['컨설팅', '솔루션'] },
                    { label: '처리 상태', path: '/admin/system/inquiries/status', tags: ['신규', '완료'] }
                ] }
            ]
        }
    };

    public async ngOnInit() {
        await this.service.init();
        this.syncActiveFromPath();
        await this.check();
    }

    public ngOnDestroy() {
        this.destroyNewsEditor();
    }

    public get activePanel() {
        return this.panels[this.activeKey] || this.panels['about-history'];
    }

    public get isHistoryPanel() {
        return this.activeKey === 'about-history';
    }

    public get isOrganizationPanel() {
        return this.activeKey === 'about-organization';
    }

    public get isPartnersPanel() {
        return this.activeKey === 'about-partners';
    }

    public get partnerRows(): PartnerItem[] {
        return this.partnersDraft?.[this.activeLang]?.data || [];
    }

    public get isPapersPanel() {
        return this.activeKey === 'research-papers';
    }

    public get isProjectsPanel() {
        return this.activeKey === 'research-projects';
    }

    public get isNewsPostsPanel() {
        return this.activeKey === 'news-posts';
    }

    public get totalMenuCount() {
        return this.menuSections.reduce((total, section) => total + section.items.length, 0);
    }

    public get historyRows(): HistoryYear[] {
        return this.historyDraft?.[this.activeLang]?.data || [];
    }

    public get historyYearCount() {
        return this.historyRows.length;
    }

    public get historyItemCount() {
        return this.historyRows.reduce((total: number, row: HistoryYear) => total + (row.items || []).length, 0);
    }

    public get teamRows(): TeamGroup[] {
        return this.teamDraft?.[this.activeLang]?.data || [];
    }

    public get teamGroupCount() {
        return this.teamRows.length;
    }

    public get teamMemberCount() {
        return this.teamRows.reduce((total: number, row: TeamGroup) => total + (row.member || []).length, 0);
    }

    public get paperRows(): PaperItem[] {
        return this.papersDraft?.data || [];
    }

    public get paperVisibleCount() {
        return this.paperRows.filter((row: PaperItem) => row.visible).length;
    }

    public get paperYearCount() {
        let years = this.paperRows
            .map((row: PaperItem) => row.year)
            .filter((year: string, index: number, rows: string[]) => year && rows.indexOf(year) === index);
        return years.length;
    }

    public get projectRows(): ProjectItem[] {
        return this.projectsDraft?.data || [];
    }

    public get projectVisibleCount() {
        return this.projectRows.filter((row: ProjectItem) => row.visible).length;
    }

    public get projectYearCount() {
        let years = this.projectRows
            .map((row: ProjectItem) => row.year)
            .filter((year: string, index: number, rows: string[]) => year && rows.indexOf(year) === index);
        return years.length;
    }

    public get newsPublishCount() {
        return this.newsStats.publish || this.newsRows.filter((row: NewsPost) => row.status === 'publish').length;
    }

    public get newsDraftCount() {
        return this.newsStats.draft || this.newsRows.filter((row: NewsPost) => row.status === 'draft').length;
    }

    public get newsPages(): number[] {
        let pages: number[] = [];
        if (this.newsPagination.start < 1 || this.newsPagination.end < 1) return pages;
        for (let page = this.newsPagination.start; page <= this.newsPagination.end; page++) pages.push(page);
        return pages;
    }

    public async check() {
        this.checking = true;
        let res = await wiz.call('check');
        this.authenticated = res.code === 200 && res.data && res.data.authenticated === true;
        this.checking = false;
        if (this.authenticated) {
            await this.loadActivePanelData();
        }
        await this.service.render();
    }

    public async login() {
        this.error = '';
        if (!this.form.password) {
            this.error = '비밀번호를 입력해주세요.';
            await this.service.render();
            return;
        }

        this.busy = true;
        let res = await wiz.call('login', { password: this.form.password });
        this.busy = false;

        if (res.code === 200) {
            this.authenticated = true;
            this.form.password = '';
            await this.loadActivePanelData(true);
        } else {
            this.error = (res.data && res.data.message) || '로그인에 실패했습니다.';
        }
        await this.service.render();
    }

    public async logout() {
        await wiz.call('logout');
        this.authenticated = false;
        this.form.password = '';
        this.error = '';
        await this.service.render();
    }

    public async select(item: any) {
        if (this.activeKey === 'news-posts' && item.key !== 'news-posts') {
            this.destroyNewsEditor();
            this.newsMode = 'list';
        }
        this.activeKey = item.key;
        this.pushAdminPath(this.activePanel.adminPath);
        await this.loadActivePanelData();
        await this.service.render();
    }

    public activeClass(key: string) {
        if (this.activeKey === key) {
            return 'admin-menu-item active';
        }
        return 'admin-menu-item';
    }

    public async setHistoryLang(lang: ContentLang) {
        this.activeLang = lang;
        await this.service.render();
    }

    public async loadHistory(force: boolean = false) {
        if (this.historyLoaded && !force) return;

        this.historyBusy = true;
        this.historyError = '';
        let res = await wiz.call('history');
        this.historyBusy = false;

        if (res.code === 200) {
            this.historyDraft = this.normalizeHistory(res.data, true);
            this.historyLoaded = true;
            this.historyDirty = false;
            this.historyMessage = 'DB 연혁 데이터를 불러왔습니다.';
        } else {
            this.historyError = (res.data && res.data.message) || '연혁 데이터를 불러오지 못했습니다.';
        }
    }

    public async saveHistory() {
        this.historySaving = true;
        this.historyError = '';
        this.historyMessage = '';

        let payload = this.normalizeHistory(this.historyDraft, false);
        let res = await wiz.call('save_history', { data: this.apiPayload(payload) });
        this.historySaving = false;

        if (res.code === 200) {
            this.historyDraft = this.normalizeHistory(res.data, true);
            this.historyDirty = false;
            this.historyLoaded = true;
            this.historyMessage = '연혁 변경사항을 저장했습니다.';
        } else {
            this.historyError = (res.data && res.data.message) || '연혁 저장에 실패했습니다.';
        }
        await this.service.render();
    }

    public async resetHistory() {
        if (!confirm('기본 연혁 데이터로 되돌릴까요? 현재 편집 내용은 사라집니다.')) return;

        this.historySaving = true;
        this.historyError = '';
        this.historyMessage = '';
        let res = await wiz.call('reset_history');
        this.historySaving = false;

        if (res.code === 200) {
            this.historyDraft = this.normalizeHistory(res.data, true);
            this.historyDirty = false;
            this.historyLoaded = true;
            this.historyMessage = '기본 연혁 데이터로 복원했습니다.';
        } else {
            this.historyError = (res.data && res.data.message) || '기본 연혁 복원에 실패했습니다.';
        }
        await this.service.render();
    }

    public markHistoryDirty() {
        this.historyDirty = true;
        this.historyMessage = '';
    }

    public async addYear() {
        this.historyRows.unshift({ year: String(new Date().getFullYear()), items: [] });
        this.markHistoryDirty();
        await this.service.render();
    }

    public async removeYear(index: number) {
        if (!confirm('이 연도와 하위 항목을 삭제할까요?')) return;
        this.historyRows.splice(index, 1);
        this.markHistoryDirty();
        await this.service.render();
    }

    public async addItem(year: HistoryYear) {
        if (!year.items) year.items = [];
        year.items.push({ month: '', title: '' });
        this.markHistoryDirty();
        await this.service.render();
    }

    public async removeItem(year: HistoryYear, index: number) {
        year.items.splice(index, 1);
        this.markHistoryDirty();
        await this.service.render();
    }

    public async moveYear(index: number, direction: number) {
        this.reorder(this.historyRows, index, index + direction);
        this.markHistoryDirty();
        await this.service.render();
    }

    public async moveItem(items: HistoryItem[], index: number, direction: number) {
        this.reorder(items, index, index + direction);
        this.markHistoryDirty();
        await this.service.render();
    }

    public async loadTeam(force: boolean = false) {
        if (this.teamLoaded && !force) return;

        this.teamBusy = true;
        this.teamError = '';
        let res = await wiz.call('team');
        this.teamBusy = false;

        if (res.code === 200) {
            this.teamDraft = this.normalizeTeam(res.data, true);
            this.teamLoaded = true;
            this.teamDirty = false;
            this.teamMessage = 'DB 조직 데이터를 불러왔습니다.';
        } else {
            this.teamError = (res.data && res.data.message) || '조직 데이터를 불러오지 못했습니다.';
        }
    }

    public async saveTeam() {
        this.teamSaving = true;
        this.teamError = '';
        this.teamMessage = '';

        let payload = this.normalizeTeam(this.teamDraft, false);
        let res = await wiz.call('save_team', { data: this.apiPayload(payload) });
        this.teamSaving = false;

        if (res.code === 200) {
            this.teamDraft = this.normalizeTeam(res.data, true);
            this.teamDirty = false;
            this.teamLoaded = true;
            this.teamMessage = '조직 변경사항을 저장했습니다.';
        } else {
            this.teamError = (res.data && res.data.message) || '조직 저장에 실패했습니다.';
        }
        await this.service.render();
    }

    public async resetTeam() {
        if (!confirm('기본 조직 데이터로 되돌릴까요? 현재 편집 내용은 사라집니다.')) return;

        this.teamSaving = true;
        this.teamError = '';
        this.teamMessage = '';
        let res = await wiz.call('reset_team');
        this.teamSaving = false;

        if (res.code === 200) {
            this.teamDraft = this.normalizeTeam(res.data, true);
            this.teamDirty = false;
            this.teamLoaded = true;
            this.teamMessage = '기본 조직 데이터로 복원했습니다.';
        } else {
            this.teamError = (res.data && res.data.message) || '기본 조직 복원에 실패했습니다.';
        }
        await this.service.render();
    }

    public markTeamDirty() {
        this.teamDirty = true;
        this.teamMessage = '';
    }

    public async addDepartment() {
        this.teamRows.push({
            id: String(Date.now()),
            team: '새 조직',
            title: '새 조직',
            detail: '',
            icon: 'icon-users',
            member: []
        });
        this.markTeamDirty();
        await this.service.render();
    }

    public async removeDepartment(index: number) {
        if (!confirm('이 조직과 하위 구성원을 삭제할까요?')) return;
        this.teamRows.splice(index, 1);
        this.markTeamDirty();
        await this.service.render();
    }

    public async addMember(group: TeamGroup) {
        if (!group.member) group.member = [];
        group.member.push({
            _key: this.nextTeamMemberKey(),
            name: '',
            affiliation: '',
            position: '',
            email: '',
            img: '',
            icon: group.icon || 'icon-user'
        });
        this.markTeamDirty();
        await this.service.render();
    }

    public async removeMember(group: TeamGroup, index: number) {
        group.member.splice(index, 1);
        this.markTeamDirty();
        await this.service.render();
    }

    public async moveDepartment(index: number, direction: number) {
        this.reorder(this.teamRows, index, index + direction);
        this.markTeamDirty();
        await this.service.render();
    }

    public async moveMember(items: TeamMember[], index: number, direction: number) {
        this.reorder(items, index, index + direction);
        this.markTeamDirty();
        await this.service.render();
    }

    public async loadPartners(force: boolean = false) {
        if (this.partnersLoaded && !force) return;
        this.partnersBusy = true;
        this.partnersError = '';
        this.partnersMessage = '';
        await this.service.render();
        try {
            const res = await wiz.call('partner');
            if (res.code !== 200 || !res.data || !Array.isArray(res.data.ko?.data) || !Array.isArray(res.data.en?.data)) {
                this.partnersError = res.data?.message || '파트너 목록을 불러오지 못했습니다.';
            } else {
                this.partnersDraft = this.normalizePartners(res.data);
                this.partnersLoaded = true;
                this.partnersDirty = false;
                this.partnersMessage = '파트너 목록을 불러왔습니다.';
            }
        } catch {
            this.partnersError = '파트너 목록을 불러오지 못했습니다.';
        }
        this.partnersBusy = false;
        await this.service.render();
    }

    public async savePartners() {
        if (!this.partnersLoaded || this.partnersBusy || this.partnersSaving || this.partnersUploading) return;
        this.partnersError = '';
        this.partnersMessage = '';
        const payload = this.normalizePartners(this.partnersDraft);
        for (const lang of ['ko', 'en'] as ContentLang[]) {
            const rows: PartnerItem[] = payload[lang].data;
            const missingLogo = rows.findIndex(row => !row.src);
            if (missingLogo >= 0) {
                this.partnersError = `${lang.toUpperCase()} ${missingLogo + 1}번째 파트너의 로고를 등록해주세요.`;
                await this.service.render();
                return;
            }
            if (rows.some(row => row.href && !/^(https?:\/\/|\/(?!\/))/i.test(row.href))) {
                this.partnersError = '파트너 링크는 https://, http:// 또는 /로 시작해야 합니다.';
                await this.service.render();
                return;
            }
        }
        this.partnersSaving = true;
        await this.service.render();
        try {
            const res = await wiz.call('save_partner', { data: this.apiPayload(payload) });
            if (res.code !== 200 || !res.data || !Array.isArray(res.data.ko?.data) || !Array.isArray(res.data.en?.data)) {
                this.partnersError = res.data?.message || '파트너 저장에 실패했습니다.';
            } else {
                this.partnersDraft = this.normalizePartners(res.data);
                this.partnersLoaded = true;
                this.partnersDirty = false;
                this.partnersMessage = '파트너 변경사항을 저장했습니다.';
            }
        } catch {
            this.partnersError = '파트너 저장에 실패했습니다.';
        }
        this.partnersSaving = false;
        await this.service.render();
    }

    public markPartnersDirty() {
        this.partnersDirty = true;
        this.partnersMessage = '';
        this.partnersError = '';
    }

    public async addPartner() {
        this.partnerRows.push({ src: '', name: '', href: '' });
        this.markPartnersDirty();
        await this.service.render();
    }

    public async removePartner(index: number) {
        this.partnerRows.splice(index, 1);
        this.markPartnersDirty();
        await this.service.render();
    }

    public async movePartner(index: number, direction: number) {
        this.reorder(this.partnerRows, index, index + direction);
        this.markPartnersDirty();
        await this.service.render();
    }

    public async uploadPartnerLogo(partner: PartnerItem, event: any) {
        const input = event?.target;
        const file = input?.files?.[0];
        if (!file) return;
        this.partnersError = '';
        if (!/^image\/(png|jpeg|webp|gif|svg\+xml)$/.test(file.type) || file.size > 5 * 1024 * 1024) {
            this.partnersError = '5MB 이하의 PNG, JPG, WebP, GIF 또는 SVG 로고를 선택해주세요.';
            input.value = '';
            await this.service.render();
            return;
        }
        this.partnersUploading = true;
        await this.service.render();
        try {
            const src = await new Promise<string>((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => typeof reader.result === 'string' ? resolve(reader.result) : reject(new Error('Invalid image'));
                reader.onerror = () => reject(reader.error || new Error('Unable to read image'));
                reader.readAsDataURL(file);
            });
            partner.src = src;
            this.markPartnersDirty();
        } catch {
            this.partnersError = '로고 파일을 읽지 못했습니다. 다시 선택해주세요.';
        }
        input.value = '';
        this.partnersUploading = false;
        await this.service.render();
    }

    public async loadPapers(force: boolean = false) {
        if (this.papersLoaded && !force) return;

        this.papersBusy = true;
        this.papersError = '';
        try {
            let res = await wiz.call('papers');
            if (res.code === 200) {
                this.papersDraft = this.normalizePapers(res.data, true);
                this.papersLoaded = true;
                this.papersDirty = false;
                this.papersMessage = 'DB 논문 데이터를 불러왔습니다.';
            } else {
                this.papersError = (res.data && res.data.message) || '논문 데이터를 불러오지 못했습니다.';
            }
        } catch {
            this.papersError = '논문 데이터를 불러오지 못했습니다.';
        }
        this.papersBusy = false;
        await this.service.render();
    }

    public async savePapers() {
        this.papersSaving = true;
        this.papersError = '';
        this.papersMessage = '';

        let payload = this.normalizePapers(this.papersDraft, false);
        let res = await wiz.call('save_papers', { data: this.apiPayload(payload) });
        this.papersSaving = false;

        if (res.code === 200) {
            this.papersDraft = this.normalizePapers(res.data, true);
            this.papersDirty = false;
            this.papersLoaded = true;
            this.papersMessage = '논문 변경사항을 저장했습니다.';
        } else {
            this.papersError = (res.data && res.data.message) || '논문 저장에 실패했습니다.';
        }
        await this.service.render();
    }

    public async resetPapers() {
        if (!confirm('기본 논문 데이터로 되돌릴까요? 현재 편집 내용은 사라집니다.')) return;

        this.papersSaving = true;
        this.papersError = '';
        this.papersMessage = '';
        let res = await wiz.call('reset_papers');
        this.papersSaving = false;

        if (res.code === 200) {
            this.papersDraft = this.normalizePapers(res.data, true);
            this.papersDirty = false;
            this.papersLoaded = true;
            this.papersMessage = '기본 논문 데이터로 복원했습니다.';
        } else {
            this.papersError = (res.data && res.data.message) || '기본 논문 복원에 실패했습니다.';
        }
        await this.service.render();
    }

    public markPapersDirty() {
        this.papersDirty = true;
        this.papersMessage = '';
    }

    public async addPaper() {
        this.paperRows.unshift({
            id: `paper-${Date.now()}`,
            no: this.nextPaperNo(),
            year: String(new Date().getFullYear()),
            title: '',
            kind: '',
            venue: '',
            link: '',
            visible: true
        });
        this.markPapersDirty();
        await this.service.render();
    }

    public async removePaper(index: number) {
        if (!confirm('이 논문 항목을 삭제할까요?')) return;
        this.paperRows.splice(index, 1);
        this.markPapersDirty();
        await this.service.render();
    }

    public async movePaper(index: number, direction: number) {
        this.reorder(this.paperRows, index, index + direction);
        this.markPapersDirty();
        await this.service.render();
    }

    public async loadProjects(force: boolean = false) {
        if (this.projectsLoaded && !force) return;

        this.projectsBusy = true;
        this.projectsError = '';
        try {
            let res = await wiz.call('projects');
            if (res.code === 200) {
                this.projectsDraft = this.normalizeProjects(res.data, true);
                this.projectsLoaded = true;
                this.projectsDirty = false;
                this.projectsMessage = 'DB 연구과제 데이터를 불러왔습니다.';
            } else {
                this.projectsError = (res.data && res.data.message) || '연구과제 데이터를 불러오지 못했습니다.';
            }
        } catch {
            this.projectsError = '연구과제 데이터를 불러오지 못했습니다.';
        }
        this.projectsBusy = false;
        await this.service.render();
    }

    public async saveProjects() {
        this.projectsSaving = true;
        this.projectsError = '';
        this.projectsMessage = '';

        let payload = this.normalizeProjects(this.projectsDraft, false);
        let res = await wiz.call('save_projects', { data: this.apiPayload(payload) });
        this.projectsSaving = false;

        if (res.code === 200) {
            this.projectsDraft = this.normalizeProjects(res.data, true);
            this.projectsDirty = false;
            this.projectsLoaded = true;
            this.projectsMessage = '연구과제 변경사항을 저장했습니다.';
        } else {
            this.projectsError = (res.data && res.data.message) || '연구과제 저장에 실패했습니다.';
        }
        await this.service.render();
    }

    public async resetProjects() {
        if (!confirm('기본 연구과제 데이터로 되돌릴까요? 현재 편집 내용은 사라집니다.')) return;

        this.projectsSaving = true;
        this.projectsError = '';
        this.projectsMessage = '';
        let res = await wiz.call('reset_projects');
        this.projectsSaving = false;

        if (res.code === 200) {
            this.projectsDraft = this.normalizeProjects(res.data, true);
            this.projectsDirty = false;
            this.projectsLoaded = true;
            this.projectsMessage = '기본 연구과제 데이터로 복원했습니다.';
        } else {
            this.projectsError = (res.data && res.data.message) || '기본 연구과제 복원에 실패했습니다.';
        }
        await this.service.render();
    }

    public markProjectsDirty() {
        this.projectsDirty = true;
        this.projectsMessage = '';
    }

    public async addProject() {
        this.projectRows.unshift({
            id: `project-${Date.now()}`,
            no: this.nextProjectNo(),
            year: String(new Date().getFullYear()),
            title: '',
            program: '',
            role: { ko: '', en: '' },
            status: { ko: '', en: '' },
            period: '',
            visible: true
        });
        this.markProjectsDirty();
        await this.service.render();
    }

    public async removeProject(index: number) {
        if (!confirm('이 연구과제 항목을 삭제할까요?')) return;
        this.projectRows.splice(index, 1);
        this.markProjectsDirty();
        await this.service.render();
    }

    public async moveProject(index: number, direction: number) {
        this.reorder(this.projectRows, index, index + direction);
        this.markProjectsDirty();
        await this.service.render();
    }

    public async loadNewsPosts(force: boolean = false, page: number = this.newsSearch.page || 1) {
        if (this.newsLoaded && !force && page === this.newsSearch.page) return;

        this.newsBusy = true;
        this.newsError = '';
        this.newsSearch.page = page;
        let res = await wiz.call('news_posts', this.newsSearch);
        this.newsBusy = false;

        if (res.code === 200) {
            let data = res.data || {};
            let rows = Array.isArray(data.rows) ? data.rows : [];
            let lastpage = data.lastpage || 0;
            let startpage = Math.floor((this.newsSearch.page - 1) / 10) * 10 + 1;
            this.newsRows = rows.map((row: any) => this.normalizeNewsPost(row, true));
            this.newsTotal = data.total || this.newsRows.length;
            this.newsStats = data.stats || this.newsStats;
            this.newsPagination.start = lastpage > 0 ? startpage : -1;
            this.newsPagination.end = lastpage > 0 ? Math.min(lastpage, startpage + 9) : -1;
            this.newsLoaded = true;
            this.newsMessage = '';
        } else {
            this.newsError = (res.data && res.data.message) || '게시글 목록을 불러오지 못했습니다.';
        }
        await this.service.render();
    }

    public async filterNews() {
        await this.loadNewsPosts(true, 1);
    }

    public async goNewsPage(page: number) {
        if (page < 1 || page === this.newsSearch.page) return;
        await this.loadNewsPosts(true, page);
    }

    public async newNewsPost() {
        this.destroyNewsEditor();
        this.newsDraft = this.emptyNewsPost();
        this.newsMode = 'edit';
        this.newsDirty = false;
        this.newsError = '';
        this.newsMessage = '';
        this.pushAdminPath('/admin/news/posts/new');
        await this.service.render();
        await this.initNewsEditor();
    }

    public async editNewsPost(row: NewsPost) {
        this.destroyNewsEditor();
        this.newsBusy = true;
        this.newsError = '';
        let res = await wiz.call('news_post', { id: row.id });
        this.newsBusy = false;

        if (res.code === 200) {
            this.newsDraft = this.normalizeNewsPost(res.data, true);
            this.newsMode = 'edit';
            this.newsDirty = false;
            this.newsMessage = '';
            this.pushAdminPath(`/admin/news/posts/${this.newsDraft.id}`);
            await this.service.render();
            await this.initNewsEditor();
        } else {
            this.newsError = (res.data && res.data.message) || '게시글을 불러오지 못했습니다.';
            await this.service.render();
        }
    }

    public async backNewsList() {
        this.destroyNewsEditor();
        this.newsMode = 'list';
        this.pushAdminPath('/admin/news/posts');
        await this.loadNewsPosts(true);
        await this.service.render();
    }

    public async saveNewsPost(backToList: boolean = false) {
        this.syncNewsEditor();
        if (!this.newsDraft.title.ko && !this.newsDraft.title.en) {
            this.newsError = '제목을 입력해주세요.';
            await this.service.render();
            return;
        }

        this.newsSaving = true;
        this.newsError = '';
        this.newsMessage = '';
        let payload = this.normalizeNewsPost(this.newsDraft, false);
        let res = await wiz.call('save_news_post', { data: this.apiPayload(payload) });
        this.newsSaving = false;

        if (res.code === 200) {
            this.newsDraft = this.normalizeNewsPost(res.data, true);
            this.newsDirty = false;
            this.newsLoaded = false;
            this.newsMessage = '게시글을 저장했습니다.';
            this.pushAdminPath(`/admin/news/posts/${this.newsDraft.id}`);
            if (backToList) {
                await this.backNewsList();
                return;
            }
            await this.service.render();
            await this.initNewsEditor();
        } else {
            this.newsError = (res.data && res.data.message) || '게시글 저장에 실패했습니다.';
            await this.service.render();
        }
    }

    public async setNewsStatus(status: string) {
        this.newsDraft.status = status === 'publish' ? 'publish' : 'draft';
        this.markNewsDirty();
        await this.saveNewsPost(false);
    }

    public async deleteNewsPost(row: NewsPost, event: Event = null) {
        if (event) event.stopPropagation();
        if (!confirm('이 게시글을 삭제할까요? 첨부 파일은 assets 폴더에 남을 수 있습니다.')) return;
        let res = await wiz.call('delete_news_post', { id: row.id });
        if (res.code === 200) {
            this.newsMessage = '게시글을 삭제했습니다.';
            this.newsLoaded = false;
            await this.loadNewsPosts(true);
        } else {
            this.newsError = (res.data && res.data.message) || '게시글 삭제에 실패했습니다.';
        }
        await this.service.render();
    }

    public async setNewsLang(lang: ContentLang) {
        if (this.activeLang === lang) return;
        this.syncNewsEditor();
        this.activeLang = lang;
        this.destroyNewsEditor();
        await this.service.render();
        await this.initNewsEditor();
    }

    public markNewsDirty() {
        this.newsDirty = true;
        this.newsMessage = '';
    }

    public newsCategoryLabel(category: string) {
        let found = this.newsCategoryOptions.find(item => item.value === category);
        return found ? found.label : category;
    }

    public newsStatusLabel(status: string) {
        let found = this.newsStatusOptions.find(item => item.value === status);
        return found ? found.label : status;
    }

    public newsDate(value: string) {
        if (!value) return '';
        return value.substring(0, 10);
    }

    public onNewsDateChange(value: string) {
        this.newsDraft.created = value ? `${value} 00:00:00` : '';
        this.markNewsDirty();
    }

    public async uploadNewsFiles(event: any, kind: string) {
        let input = event.target;
        let files = input?.files ? Array.from(input.files) : [];
        if (files.length === 0) return;
        await this.uploadNewsAssetList(files, kind);
        input.value = '';
    }

    public async removeNewsAsset(asset: any) {
        if (!this.newsDraft.id) return;
        if (!confirm('이 첨부파일을 삭제할까요?')) return;
        this.newsSaving = true;
        this.newsError = '';
        let res = await wiz.call('remove_news_asset', { id: this.newsDraft.id, target: asset.id || asset.url || asset.name });
        this.newsSaving = false;
        if (res.code === 200) {
            this.newsDraft = this.normalizeNewsPost(res.data, true);
            this.newsDirty = false;
            this.newsMessage = '첨부파일을 삭제했습니다.';
        } else {
            this.newsError = (res.data && res.data.message) || '첨부파일 삭제에 실패했습니다.';
        }
        await this.service.render();
    }

    public async makeFeatured(asset: any) {
        this.newsDraft.featured_image = asset.url || '';
        this.markNewsDirty();
        await this.service.render();
    }

    public iconLabel(icon: string) {
        let found = this.iconOptions.find(item => item.value === icon);
        return found ? found.label : icon;
    }

    public adminStatusText(message: string, fallback: string = '상태') {
        let text = String(message || '').trim();
        if (!text) return fallback;

        let failed = text.includes('실패') || text.includes('못했') || text.includes('오류') || text.includes('해주세요') || text.includes('CKEditor');
        if (failed) {
            if (text.includes('업로드')) return '업로드 실패';
            if (text.includes('삭제')) return '삭제 실패';
            if (text.includes('저장')) return '저장 실패';
            if (text.includes('복원') || text.includes('초기')) return '복원 실패';
            if (text.includes('불러') || text.includes('로드') || text.includes('CKEditor')) return '로드 실패';
            if (text.includes('제목') || text.includes('입력')) return '입력 필요';
            return fallback;
        }

        if (text.includes('업로드')) return '업로드됨';
        if (text.includes('삭제')) return '삭제됨';
        if (text.includes('저장')) return '저장됨';
        if (text.includes('복원') || text.includes('초기')) return '복원됨';
        if (text.includes('불러')) return '불러옴';
        if (text.length <= 8) return text;
        return fallback;
    }

    public trackByIndex(index: number) {
        return index;
    }

    public trackBySortableItem(index: number, item: any) {
        return item?.id || item?._key || item;
    }

    public trackByTeamGroup(index: number, group: TeamGroup) {
        return group?.id || `${group?.team || 'team'}-${index}`;
    }

    public trackByTeamMember(index: number, member: TeamMember) {
        return member?._key || member?.email || `${member?.name || 'member'}-${index}`;
    }

    private async loadActivePanelData(force: boolean = false) {
        if (this.isHistoryPanel) {
            await this.loadHistory(force);
            return;
        }
        if (this.isOrganizationPanel) {
            await this.loadTeam(force);
            return;
        }
        if (this.isPartnersPanel) {
            await this.loadPartners(force);
            return;
        }
        if (this.isPapersPanel) {
            await this.loadPapers(force);
            return;
        }
        if (this.isProjectsPanel) {
            await this.loadProjects(force);
            return;
        }
        if (this.isNewsPostsPanel) {
            let postId = this.newsPostIdFromPath();
            if (postId > 0) {
                await this.editNewsPost({ ...this.emptyNewsPost(), id: postId });
                return;
            }
            if (window.location.pathname.endsWith('/new')) {
                await this.newNewsPost();
                return;
            }
            await this.loadNewsPosts(force);
        }
    }

    private syncActiveFromPath() {
        let path = window.location.pathname;
        const routes = Object.keys(this.panels).flatMap(key =>
            [this.panels[key].adminPath, ...(this.panels[key].aliases || [])].map(adminPath => ({ key, adminPath }))
        ).sort((a, b) => b.adminPath.length - a.adminPath.length);
        const matched = routes.find(route => path === route.adminPath || path.startsWith(`${route.adminPath}/`));
        if (matched) this.activeKey = matched.key;
        if (this.activeKey === 'news-posts') {
            this.newsMode = path === '/admin/news/posts' ? 'list' : 'edit';
        }
    }

    private newsPostIdFromPath() {
        let matched = window.location.pathname.match(/^\/admin\/news\/posts\/(\d+)$/);
        return matched ? Number(matched[1]) : 0;
    }

    private pushAdminPath(path: string) {
        if (!path || window.location.pathname === path) return;
        window.history.pushState({}, '', path);
    }

    private afterHistorySort() {
        this.markHistoryDirty();
        this.service.render();
    }

    private afterTeamSort() {
        this.markTeamDirty();
        this.service.render();
    }

    private afterPaperSort() {
        this.markPapersDirty();
        this.service.render();
    }

    private afterProjectSort() {
        this.markProjectsDirty();
        this.service.render();
    }

    private reorder(items: any[], oldIndex: number, newIndex: number) {
        if (!items || newIndex < 0 || newIndex >= items.length || oldIndex === newIndex) return;
        let target = items.splice(oldIndex, 1)[0];
        items.splice(newIndex, 0, target);
    }

    private apiPayload(data: any) {
        return JSON.stringify(data);
    }

    private async initNewsEditor() {
        if (!this.isNewsPostsPanel || this.newsMode !== 'edit') return;
        this.destroyNewsEditor();
        let editorEl: any = document.getElementById(`news-content-${this.activeLang}`);
        if (!editorEl) return;
        let ClassicEditor = await this.ensureClassicEditor();
        if (!ClassicEditor) return;
        this.newsEditor = await ClassicEditor.create(editorEl, {
            language: this.activeLang,
            toolbar: {
                items: [
                    'heading', '|', 'fontColor', 'highlight', 'fontBackgroundColor',
                    'bold', 'italic', 'strikethrough', 'underline',
                    'bulletedList', 'numberedList', 'todoList', 'blockQuote',
                    '|', 'outdent', 'indent', '|', 'link', 'imageUpload',
                    'insertTable', 'undo', 'redo', 'code', 'codeBlock',
                    'horizontalLine', 'removeFormat'
                ]
            }
        });
        this.newsEditor.setData(this.newsDraft.content[this.activeLang] || '');
        this.newsEditor.model.document.on('change:data', () => {
            this.newsDraft.content[this.activeLang] = this.newsEditor.getData();
            this.markNewsDirty();
        });
        let fileRepository = this.newsEditor.plugins.get('FileRepository');
        fileRepository.createUploadAdapter = (loader: any) => this.createNewsUploadAdapter(loader);
        this.ckeditorReady = true;
        await this.service.render();
    }

    private destroyNewsEditor() {
        if (!this.newsEditor) return;
        let editor = this.newsEditor;
        this.newsEditor = null;
        editor.destroy();
    }

    private syncNewsEditor() {
        if (!this.newsEditor) return;
        this.newsDraft.content[this.activeLang] = this.newsEditor.getData();
    }

    private async ensureClassicEditor() {
        let win: any = window as any;
        if (win.ClassicEditor) return win.ClassicEditor;
        if (!this.ckeditorPromise) {
            this.ckeditorPromise = new Promise((resolve) => {
                let existing: any = document.querySelector('script[data-season-ckeditor]');
                if (existing) {
                    existing.addEventListener('load', () => resolve(win.ClassicEditor || null));
                    existing.addEventListener('error', () => resolve(null));
                    return;
                }
                let script = document.createElement('script');
                script.setAttribute('data-season-ckeditor', 'true');
                script.src = '/lib/ckeditor/ckeditor.js';
                script.onload = () => resolve(win.ClassicEditor || null);
                script.onerror = () => resolve(null);
                document.head.appendChild(script);
            });
        }
        let editor = await this.ckeditorPromise;
        if (!editor) this.newsError = 'CKEditor를 불러오지 못했습니다.';
        return editor;
    }

    private createNewsUploadAdapter(loader: any) {
        return {
            upload: async () => {
                let file = await loader.file;
                let uploaded = await this.uploadNewsAssetList([file], 'content');
                let item = uploaded && uploaded.length > 0 ? uploaded[0] : null;
                if (!item || !item.url) throw new Error('업로드에 실패했습니다.');
                return { default: item.url };
            },
            abort: () => { }
        };
    }

    private async uploadNewsAssetList(files: any[], kind: string) {
        this.syncNewsEditor();
        await this.ensureNewsPostId();
        if (!this.newsDraft.id) return [];

        this.newsUploading = true;
        this.newsError = '';
        let fd = new FormData();
        fd.append('id', String(this.newsDraft.id));
        fd.append('kind', kind);
        files.forEach((file: any) => fd.append('file[]', file));
        let res: any = await this.service.file.upload(wiz.url('upload_news_asset'), fd);
        this.newsUploading = false;

        if (res.code === 200) {
            let data = res.data || {};
            this.newsDraft = this.normalizeNewsPost(data.post || this.newsDraft, true);
            this.newsDirty = false;
            this.newsMessage = '파일을 업로드했습니다.';
            await this.service.render();
            return data.files || [];
        }

        this.newsError = (res.data && res.data.message) || '파일 업로드에 실패했습니다.';
        await this.service.render();
        return [];
    }

    private async ensureNewsPostId() {
        if (this.newsDraft.id > 0) return;
        await this.saveNewsPost(false);
    }

    private normalizeNewsPost(data: any, keepEmpty: boolean): NewsPost {
        let normalized = this.emptyNewsPost();
        if (!data || typeof data !== 'object') return normalized;
        normalized.id = this.numberValue(data.id, 0);
        normalized.category = this.newsCategoryValue(data.category);
        normalized.status = data.status === 'publish' ? 'publish' : 'draft';
        normalized.title = this.localText(data.title);
        normalized.content = this.localText(data.content);
        normalized.featured_image = this.text(data.featured_image);
        normalized.upload_dir = this.text(data.upload_dir);
        normalized.source_url = this.text(data.source_url);
        normalized.created = this.text(data.created) || this.defaultNewsDate();
        normalized.attachments = Array.isArray(data.attachments)
            ? data.attachments
                .filter((item: any) => item && typeof item === 'object')
                .map((item: any, index: number) => ({
                    id: this.text(item.id) || `asset-${index}`,
                    name: this.text(item.name),
                    type: this.text(item.type) || 'file',
                    mime: this.text(item.mime),
                    size: this.numberValue(item.size, 0),
                    url: this.text(item.url)
                }))
                .filter((item: any) => keepEmpty || item.url || item.name)
            : [];
        return normalized;
    }

    private normalizeHistory(data: any, keepEmpty: boolean) {
        let normalized: any = this.emptyHistory();
        if (!data || typeof data !== 'object') return normalized;

        (['ko', 'en'] as ContentLang[]).forEach(lang => {
            let rows = data?.[lang]?.data;
            if (!Array.isArray(rows)) rows = [];

            normalized[lang].data = rows
                .filter((row: any) => row && typeof row === 'object')
                .map((row: any) => {
                    let year = this.text(row.year);
                    let rawItems = Array.isArray(row.items) ? row.items : [];
                    let items = rawItems
                        .filter((item: any) => item && typeof item === 'object')
                        .map((item: any) => ({
                            month: this.text(item.month),
                            title: this.text(item.title)
                        }))
                        .filter((item: HistoryItem) => keepEmpty || item.month || item.title);
                    return { year, items };
                })
                .filter((row: HistoryYear) => keepEmpty || row.year);
        });

        return normalized;
    }

    private normalizeTeam(data: any, keepEmpty: boolean) {
        let normalized: any = this.emptyTeam();
        if (!data || typeof data !== 'object') return normalized;

        (['ko', 'en'] as ContentLang[]).forEach(lang => {
            let rows = data?.[lang]?.data;
            if (!Array.isArray(rows)) rows = [];

            normalized[lang].data = rows
                .filter((row: any) => row && typeof row === 'object')
                .map((row: any, index: number) => {
                    let rawMembers = Array.isArray(row.member) ? row.member : [];
                    let members = rawMembers
                        .filter((member: any) => member && typeof member === 'object')
                        .map((member: any) => {
                            let normalizedMember: any = {
                                name: this.text(member.name),
                                affiliation: this.text(member.affiliation),
                                position: this.text(member.position),
                                email: this.text(member.email),
                                img: this.text(member.img),
                                icon: this.iconValue(member.icon, 'icon-user')
                            };
                            if (keepEmpty) {
                                normalizedMember._key = this.text(member._key) || this.nextTeamMemberKey();
                            }
                            return normalizedMember;
                        })
                        .filter((member: TeamMember) => keepEmpty || member.name || member.affiliation || member.position || member.email || member.img);

                    return {
                        id: this.text(row.id) || String(index + 1),
                        team: this.text(row.team),
                        title: this.text(row.title),
                        detail: this.text(row.detail),
                        icon: this.iconValue(row.icon, 'icon-users'),
                        member: members
                    };
                })
                .filter((row: TeamGroup) => keepEmpty || row.team || row.title || row.detail || row.member.length > 0);
        });

        return normalized;
    }

    private normalizePapers(data: any, keepEmpty: boolean) {
        let normalized: any = this.emptyPapers();
        if (!data || typeof data !== 'object') return normalized;

        let rows = data.data;
        if (!Array.isArray(rows)) rows = [];

        normalized.data = rows
            .filter((row: any) => row && typeof row === 'object')
            .map((row: any, index: number) => ({
                id: this.text(row.id) || `paper-${Date.now()}-${index}`,
                no: this.numberValue(row.no, index + 1),
                year: this.text(row.year),
                title: this.text(row.title),
                kind: this.text(row.kind),
                venue: this.text(row.venue),
                link: this.text(row.link),
                visible: this.booleanValue(row.visible, true)
            }))
            .filter((row: PaperItem) => keepEmpty || row.title);

        return normalized;
    }

    private normalizeProjects(data: any, keepEmpty: boolean) {
        let normalized: any = this.emptyProjects();
        if (!data || typeof data !== 'object') return normalized;

        let rows = data.data;
        if (!Array.isArray(rows)) rows = [];

        normalized.data = rows
            .filter((row: any) => row && typeof row === 'object')
            .map((row: any, index: number) => ({
                id: this.text(row.id) || `project-${Date.now()}-${index}`,
                no: this.numberValue(row.no, index + 1),
                year: this.text(row.year),
                title: this.text(row.title),
                program: this.text(row.program),
                role: this.localText(row.role),
                status: this.localText(row.status),
                period: this.text(row.period),
                visible: this.booleanValue(row.visible, true)
            }))
            .filter((row: ProjectItem) => keepEmpty || row.title);

        return normalized;
    }

    private emptyHistory() {
        return {
            id: 'history',
            ko: { data: [] },
            en: { data: [] }
        };
    }

    private emptyTeam() {
        return {
            id: 'team',
            ko: { data: [] },
            en: { data: [] }
        };
    }

    private normalizePartners(data: any) {
        const normalized = this.emptyPartners();
        (['ko', 'en'] as ContentLang[]).forEach(lang => {
            const rows = data?.[lang]?.data;
            if (!Array.isArray(rows)) return;
            normalized[lang].data = rows
                .filter((row: any) => typeof row === 'string' || (row && typeof row === 'object'))
                .map((row: any) => {
                    if (typeof row === 'string') return { src: this.text(row), name: '', href: '' };
                    const url = this.text(row.url);
                    const imageUrl = /^(data:image|\/)/i.test(url) || /\.(png|jpe?g|webp|svg|gif)(\?|$)/i.test(url);
                    return {
                        src: this.text(row.src || row.logo || row.logoUrl || row.image || row.imageUrl || (imageUrl ? url : '')),
                        name: this.text(row.name || row.title),
                        href: this.text(row.href || row.link || row.website || (!imageUrl ? url : ''))
                    };
                });
        });
        return normalized;
    }

    private emptyPartners(): { id: string; ko: { data: PartnerItem[] }; en: { data: PartnerItem[] } } {
        return { id: 'partner', ko: { data: [] }, en: { data: [] } };
    }

    private emptyPapers() {
        return {
            id: 'research_papers',
            data: []
        };
    }

    private emptyProjects() {
        return {
            id: 'research_projects',
            data: []
        };
    }

    private emptyNewsPost(): NewsPost {
        return {
            id: 0,
            category: 'notice',
            status: 'draft',
            title: { ko: '', en: '' },
            content: { ko: '', en: '' },
            featured_image: '',
            upload_dir: '',
            attachments: [],
            source_url: '',
            created: this.defaultNewsDate()
        };
    }

    private defaultNewsDate() {
        let today = new Date();
        let month = String(today.getMonth() + 1).padStart(2, '0');
        let day = String(today.getDate()).padStart(2, '0');
        return `${today.getFullYear()}-${month}-${day} 00:00:00`;
    }

    private nextPaperNo() {
        if (this.paperRows.length === 0) return 1;
        return Math.max(...this.paperRows.map((row: PaperItem) => this.numberValue(row.no, 0))) + 1;
    }

    private nextProjectNo() {
        if (this.projectRows.length === 0) return 1;
        return Math.max(...this.projectRows.map((row: ProjectItem) => this.numberValue(row.no, 0))) + 1;
    }

    private nextTeamMemberKey() {
        return `team-member-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    }

    private numberValue(value: any, fallback: number) {
        let parsed = Number(value);
        if (!Number.isFinite(parsed)) return fallback;
        return parsed;
    }

    private booleanValue(value: any, fallback: boolean) {
        if (typeof value === 'boolean') return value;
        if (value === null || value === undefined) return fallback;
        if (value === 0 || value === '0' || value === 'false') return false;
        if (value === 1 || value === '1' || value === 'true') return true;
        return fallback;
    }

    private iconValue(value: any, fallback: string) {
        let icon = this.text(value);
        if (!icon || icon.indexOf('icon-') !== 0) return fallback;
        return icon;
    }

    private newsCategoryValue(value: any) {
        let category = this.text(value);
        return this.newsCategoryOptions.some(item => item.value === category) ? category : 'notice';
    }

    private localText(value: any): LocalText {
        if (value && typeof value === 'object') {
            return {
                ko: this.text(value.ko),
                en: this.text(value.en)
            };
        }
        let text = this.text(value);
        return { ko: text, en: text };
    }

    private text(value: any) {
        if (value === null || value === undefined) return '';
        return String(value).trim();
    }
}

export default PageAdminComponent;